import HTTP from '../HTTP';

const URL_BASE = 'clients';

export async function GetPiecesJointesAsync(elementId) {
  const response = await HTTP.get(URL_BASE + '/piecesJointes/' + elementId);
  return response;
}

export async function createPiecesJointes(fd) {
  const response = await HTTP.post(URL_BASE + '/create/piecesJointes', fd);
  return response;
}

export async function GetPJAsync(elementId) {
  const response = await HTTP.get(URL_BASE + '/pJAll/' + elementId);
  return response;
}

export async function updatePiecesJointes(fd) {
  const response = await HTTP.put(URL_BASE + '/update/piecesJointes', fd);
  return response;
}



// WEBPACK FOOTER //
// ./src/api/pieceJointes/index.js